/**
 *
 * LoadingContainer
 *
 */
import React, { memo } from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
import { LoadingContainerWrapper } from './styled';

interface Props {
  loading?: boolean;
  description?: string;
  children?: React.ReactNode;
}

const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

export const LoadingContainer = memo(
  ({ loading = false, description = '', children }: Props) => {
    return (
      <LoadingContainerWrapper>
        <Spin indicator={antIcon} tip={description} spinning={loading}>
          {children}
        </Spin>
      </LoadingContainerWrapper>
    );
  },
);

export default LoadingContainer;
